module.exports = __webpack_public_path__ + "static/img/brand-12.66f8450.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-12.svg
// module id = jgRx
// module chunks = 0